/* ============================================
   COLLECTION LOAD MORE / INFINITE SCROLL (BFE) — TDTP
   ============================================
   Plakt vervolgpagina's aan dezelfde product-grid i.p.v. genummerde paginatie.
   - Progressive enhancement: de knop heeft een echte ?page-href (SEO + no-JS).
   - Werkt naast Pipeline's AJAX-filter: de knop leeft binnen [data-products-grid],
     dus na een filteractie bouwt de server 'm opnieuw op. Click = event-delegation
     (overleeft DOM-vervanging). Infinite = IntersectionObserver, met MutationObserver
     die nieuwe knoppen na een filterwissel opnieuw observeert.
   - Images zijn native loading="lazy"; card-interactiviteit is delegated → aangeplakte
     items werken vanzelf.

   Versie: 1.0 - 30-06-2026
   ============================================ */
(function () {
  if (window.__loadmoreBfe) return;
  window.__loadmoreBfe = true;

  var SEL = '[data-loadmore-bfe]';
  var LOADING = 'is-loading-bfe';
  var observed = new WeakSet();
  var io = null;

  function gridFrom(btn) {
    var wrap = btn.closest('[data-products-grid]');
    return wrap ? wrap.querySelector('.js-grid') : null;
  }

  function cleanHref(raw) {
    try {
      var u = new URL(raw, window.location.origin);
      u.searchParams.delete('section_id');
      return u.pathname + u.search;
    } catch (e) { return raw; }
  }

  function load(btn) {
    if (!btn || btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';
    btn.classList.add(LOADING);

    var sid = btn.getAttribute('data-section-id');
    var fetchUrl;
    try {
      var u = new URL(btn.getAttribute('href'), window.location.origin);
      u.searchParams.set('section_id', sid);
      fetchUrl = u.toString();
    } catch (e) {
      fetchUrl = btn.getAttribute('href');
    }

    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var newGrid = tmp.querySelector('.js-grid');
        var curGrid = gridFrom(btn);
        if (newGrid && curGrid) {
          while (newGrid.children.length) {
            curGrid.appendChild(newGrid.children[0]); // verplaatst de node
          }
        }

        var newBtn = tmp.querySelector(SEL);
        var wrap = btn.closest('[data-loadmore-wrap-bfe]');
        if (newBtn) {
          btn.setAttribute('href', cleanHref(newBtn.getAttribute('href')));
          btn.dataset.loading = '';
          btn.classList.remove(LOADING);
          maybeObserve(btn); // volgende pagina blijven auto-laden bij infinite
        } else if (wrap && wrap.parentNode) {
          wrap.parentNode.removeChild(wrap); // geen volgende pagina meer
        }
      })
      .catch(function () {
        btn.dataset.loading = '';
        btn.classList.remove(LOADING);
      });
  }

  function maybeObserve(btn) {
    if (!btn || btn.getAttribute('data-loadmore-style') !== 'infinite') return;
    if (!('IntersectionObserver' in window)) return;
    if (observed.has(btn)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          observed.delete(en.target);
          load(en.target);
        });
      }, { rootMargin: '600px 0px' });
    }
    observed.add(btn);
    io.observe(btn);
  }

  function scan() {
    var btns = document.querySelectorAll(SEL + '[data-loadmore-style="infinite"]');
    for (var i = 0; i < btns.length; i++) maybeObserve(btns[i]);
  }

  // Click (Load more) — gedelegeerd, overleeft DOM-vervanging door de filter
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!btn) return;
    e.preventDefault();
    load(btn);
  });

  // Infinite: observeer nu + opnieuw nadat de AJAX-filter de grid vervangt
  function boot() {
    scan();
    var containers = document.querySelectorAll('[data-products-grid]');
    if (containers.length && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { scan(); });
      containers.forEach(function (c) { mo.observe(c, { childList: true, subtree: true }); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
